module.exports = __webpack_public_path__ + "static/notco-335e08a76ad001822f19402959027a4c.png";